module.exports = __webpack_public_path__ + "img/liwu.04c31c8a.webp";